<template>
  <div :class="$style.wrapper">
    <div :class="$style.checkboxWrapper">
      <input
        type="checkbox"
        :value="props.value"
        :name="props.name"
        :id="props.id"
        v-model="model"
      />
      <div :class="checkboxViewClassObj"></div>
    </div>
    <span :for="props.id" :class="labelClassObj">
      <slot></slot>
    </span>
  </div>
</template>

<script setup>
import { defineModel, useCssModule, computed, defineProps } from "vue";
const model = defineModel();
const $style = useCssModule();

const props = defineProps(["labelClass", "error", "value", "name", "id"]);

const checkboxViewClassObj = computed(() => ({
  [$style.checkboxView]: true,
  [$style.active]: Array.isArray(model.value)
    ? model.value.includes(props.name)
    : model.value,
  [$style.error]: props.error,
}));

const labelClassObj = computed(() => ({
  [$style.label]: true,
  [props.labelClass]: props.labelClass,
}));
</script>

<style module lang="scss">
.wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  .checkboxWrapper {
    height: 16px;
    width: 16px;
    position: relative;

    input {
      height: 16px;
      width: 16px;
      margin: 0;
      opacity: 0;
      cursor: pointer;
    }

    .checkboxView {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      pointer-events: none;
      border-radius: 4px;
      border: 2px solid #050505;
      background-size: cover;
      background-position: center center;

      &.active {
        background-image: url("@/images/icons/checkbox.svg");
      }

      &.error {
        border: 2px solid #d83f48;
      }
    }
  }

  .label {
    cursor: pointer;
    overflow: hidden;
    color: var(--Text-primary, #212122);
    text-overflow: ellipsis;
    font-family: "Noto Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.56px;
    margin-bottom: 0;
  }
}
</style>
